const core = {
  limitsTitle: 'アップロードできるCADデータと上限',
  limitsMaxSize: '1ファイルの上限: {{size}} MB',
  limitsFormats: '対応形式: {{types, list}}',
  limitsBatch: '肉厚解析で一度に処理できる件数: {{count}} 件',
  limitsThicknessEnabled: '肉厚解析: 利用可能',
  limitsThicknessDisabled: '肉厚解析: このテナントでは利用できません',
  limitsDisabled: 'CAD機能はこのテナントでは有効化されていません。',
  title: '3D CADビューア',
  prototype: 'プロトタイプ',
  disabledTitle: '3D CADビューアは利用できません',
  disabled: 'この機能は現在の環境では無効になっています。管理者にお問い合わせください。',
  loadModelsFailed: 'モデル一覧の取得に失敗しました',
  comparisonFailed: '比較に失敗しました: {{message}}',
  deleteFailed: '削除に失敗しました',
  drbfmLoading: 'DRBFM結果を読み込み中...',
  drbfmLoadFailed: 'DRBFM結果取得失敗: {{message}}',
  drbfmLinked: 'DRBFM セッション連携中: {{shown}} / {{total}} 件の失敗モードを {{locations}} 箇所に表示',
  drbfmNoMatchingModel: 'DRBFM セッションに紐づくCADモデルが選択されていません ({{total}} 件のマーカーは別モデル)',
  uploadedModels: 'アップロード済み ({{count}})',
  comparisonTarget: '比較対象',
  comparing: '比較中...',
  startComparison: '比較開始',
  comparisonMode: '比較モード',
  confidenceLabel: '信頼度: {{value}}',
  exitComparisonMode: '比較モードを終了',
  switchModelConfirm: {
      title: 'モデルを切り替える',
      description:
        '現在のチャット内容とマーカーは破棄されます。この画面から復元することはできません。切り替えてもよろしいですか？',
      confirm: '切り替える',
    },
  metadataTab: 'メタデータ',
  aiAnalysisTab: 'AI分析',
  chatTab: 'チャット',
  modeSwitch: {
      toThickness: '肉厚チェックに切り替え',
      toViewer: '3D CADビューアに戻る',
    },
  thickness: {
      errorCodes: {
        conversionFailed: 'CADの3D変換に失敗しました。ファイルを再エクスポートして再度アップロードしてください。',
        analysisFailed: '肉厚解析に失敗しました。形状と解析条件を確認してください。',
        originalMissing: '元のCADファイルが見つかりません。再度アップロードしてください。',
        internalError: '内部エラーが発生しました。モデルIDを添えて運用担当にご連絡ください。',
      },
      title: '肉厚チェック',
      disabledTitle: '肉厚チェックは利用できません',
      disabled: 'このテナントでは肉厚チェック機能は有効になっていません。',
      subtitle: '面単位表示・違反領域・検証帳票',
      scopeNotice: '判定結果と解析品質は別に表示します。穴や複雑形状の結果は制約表示を確認し、人によるCAD確認と併用してください。複数ボディは全ボディを解析します。',
      viewerReadOnly: '閲覧権限では結果表示と帳票ダウンロードのみ利用できます。',
      selectModel: '左の一覧からCADモデルを選択してください。',
      modelProcessing: 'CADモデルを変換中です。完了後に肉厚解析を開始できます。',
      modelFailed: 'CADモデルの変換に失敗しました。',
      loadFailed: '肉厚解析履歴の取得に失敗しました。',
      rateLimited: 'アクセスが集中しています。{{seconds}}秒後に再試行できます。',
      retryLoad: '再試行',
      retryHint: '自動再試行後も取得できませんでした。{{seconds}}秒待ってから再試行してください。',
      analysisNotFound: 'リンクで指定された解析ID「{{analysisId}}」は存在しません。別の解析結果は表示していません。解析履歴から正しいrunを選択してください。',
      regionNotFound: 'リンクで指定された違反領域「{{regionId}}」は、この解析結果に存在しません。',
      selectValidAnalysis: '有効な解析runを選択',
      startFailed: '肉厚解析を開始できませんでした。',
      reportFailed: '検証Excelをダウンロードできませんでした。',
      analysisConditions: '解析条件',
      preset: {
        label: '条件プリセット',
        none: 'プリセットなし',
        name: 'プリセット名',
        save: '版として保存',
        nameRequired: 'プリセット名を入力してください。',
        loadFailed: 'プリセットを取得できませんでした。',
        saveFailed: 'プリセットを保存できませんでした。',
      },
      lower: '下限 mm',
      upper: '上限 mm',
      tolerance: '公差 mm',
      toleranceHelp: '解析値は変更せず、最終判定範囲を {{lower}}〜{{upper}} mm とします。',
      profile: '解析精度',
      profileValues: {
        standard: '標準',
        medium: '中',
        coarse: '粗',
      },
      config: {
        invalidRange: '下限値は上限値以下にしてください。',
        invalidNumber: '下限・上限・公差には0以上の数値を入力してください。',
      },
      start: '解析開始',
      history: '解析履歴',
      analysisRun: '解析run',
      latestSuccessful: '最新成功',
      noHistory: '解析履歴はありません。',
      comparison: {
        base: '比較元run',
        run: '差分',
        failed: '解析runを比較できませんでした。',
        delta: '薄肉領域 {{thin}} / 厚肉領域 {{thick}} / 変化CAD面 {{faces}}（比較先−比較元）',
        assessment: {
          improved: '違反領域が減少しました。',
          regressed: '違反領域が増加しました。',
          unchanged: '違反領域数に変化はありません。',
        },
      },
      retry: '別runとして再実行',
      analysisFailed: '解析に失敗しました。',
      analysisRunning: '解析中です。完了後に自動更新します。',
      recover: '停止したrunを再開',
      recoverFailed: '停止した解析を再開できませんでした。',
      attempt: '実行 {{count}} 回目',
      keepLatestSuccessful: '3D表示は直近の成功結果を保持しています。',
      result: '解析結果',
      smoothView: '滑らか表示',
      flatView: '面単位表示',
      legend: {
        title: '面単位表示の凡例',
        thin: '薄肉',
        within: '基準内',
        thick: '厚肉',
        tolerance: '公差適用',
        unmeasured: '未測定・未抽出',
      },
      thinRegions: '薄肉領域',
      thickRegions: '厚肉領域',
      measuredPoints: '測定点',
      pointSupplement: '補足: 薄肉 {{thin}}点 / 厚肉 {{thick}}点 / 孤立違反 {{isolated}}点 / 公差救済 {{rescued}}点',
      directionReviewRequired: '方向判定の要レビュー {{count}}点（違反件数には含めていません）',
      directionReviewReason: {
        outward_direction_fallback: '外向きレイへのフォールバック: {{count}}点',
        same_surface_intersection: '同一CAD面への交差: {{count}}点',
        opposite_surface_ambiguous: '相手面の向きが非対向: {{count}}点',
        long_body_span: '部品全長に近い長手方向距離: {{count}}点',
      },
      faceSummaries: '元CAD面単位の集約（{{count}}面）',
      faceSummary: '最小 {{min}} / 平均 {{mean}} / 中央 {{median}} / P05 {{p05}} / P95 {{p95}} mm\n有効 {{measured}} / 全{{total}}点・薄肉 {{thin}} / 基準内 {{within}} / 厚肉 {{thick}} / 未測定 {{unmeasured}}点',
      faceJudgment: {
        mixed: '薄肉・厚肉混在',
        thin: '薄肉あり',
        within_range: '基準内',
        thick: '厚肉あり',
        unmeasured: '未測定',
      },
      limitations: '解析上の制約',
      downloadReport: '検証Excel',
      downloadPdf: '共有PDF',
      violationRegions: '違反領域（{{count}}）',
      noViolations: '設定した最終判定範囲外の領域はありません。',
      thin: '薄肉',
      thick: '厚肉',
      smoothShadingCaveat: '滑らか表示はメッシュ頂点間の色を補間するため、CAD上で均一な面でも隣接面やエッジの影響でグラデーションに見える場合があります。面内の肉厚変化を判断するときは「{{faceView}}」とCAD照合を使用してください。',
      technicalDetail: '（技術詳細）',
      regionCentroidPrecise: '領域中心: X {{x}} / Y {{y}} / Z {{z}} mm',
      regionExtremeThin: '最薄代表測定点: X {{x}} / Y {{y}} / Z {{z}} mm',
      regionExtremeThick: '最厚代表測定点: X {{x}} / Y {{y}} / Z {{z}} mm',
      regionSourceFaces: 'CAD面: {{ids}}',
      reportFileSlug: '肉厚チェック',
      regionSummary: '最小 {{min}} / 平均 {{mean}} / 最大 {{max}} mm・{{count}}点\n中心 X {{x}} / Y {{y}} / Z {{z}} mm\n代表位置 X {{extremeX}} / Y {{extremeY}} / Z {{extremeZ}} mm・CAD面 {{sourceFaceCount}}件 / ボディ {{sourceBodyCount}}件（Mesh面 {{faceCount}}件）',
      regionKind: {
        cluster: '近接集約',
        isolated: '孤立点',
      },
      quality: {
        reliable: '解析品質: 良好',
        provisional: '解析品質: 暫定',
        limited: '解析品質: 制限あり',
      },
      qualitySource: '正式表示: 肉厚解析エンジン {{engine}}・完了 {{completedAt}}。メタデータタブの旧ジオメトリ推定は参考値です。',
      review: {
        title: '確認・承認',
        regionDisposition: '選択領域の確認結果',
        comment: '確認コメント',
        save: '確認内容を保存',
        approve: '結果を承認',
        reject: '差戻し',
        loadFailed: '確認・承認状態を取得できませんでした。',
        saveFailed: '確認内容を保存できませんでした。',
        measurementNonNegative: 'CAD実測値は0以上の数値を入力してください',
        conflict: '別の利用者が確認内容を更新しました。最新内容を再読込したため、内容を確認して再度保存してください。',
        status: {
          unreviewed: '未確認',
          in_review: '確認中',
          approved: '承認済み',
          rejected: '差戻し',
        },
        disposition: {
          unreviewed: '未確認',
          requires_change: '設計変更が必要',
          accepted: '許容',
          false_positive: '誤検出',
          needs_confirmation: '追加確認が必要',
        },
        stepFlow: '4 Step 確認フロー',
        stepsLabel: '確認手順',
        steps: {
          analysisCheck: '解析確認',
          cadVerification: 'CAD照合',
          designAction: '設計処置',
          saveExport: '保存・出力',
        },
        selectRegionHint: '違反領域を選ぶと、該当位置を3Dで拡大しながら確認記録を残せます。',
        analysisConfirmed: '解析品質と対象位置を確認した',
        violationRegion: '違反領域',
        regionPointCount: '1領域（測定点 {{count}}点）',
        representative: '代表値',
        representativeSummary: '最小 {{min}} / 平均 {{mean}} mm',
        accuracyDisclaimer: '「代表10点すべて誤差20%以内」は2つの解析方法間の検証結果です。CAD実測値との完全一致や製品合否精度100%を意味しません。',
        cadVerificationLabel: 'CAD照合方法',
        cadVerificationMode: {
          analysis_value: '解析値を採用',
          cad_measured: 'CADで実測',
          reanalyze: '要再解析',
        },
        cadMeasured: 'CAD実測値 (mm)',
        analysisDifference: '解析値との差',
        measurementMethod: '測定方法・箇所',
        measurementMethodPlaceholder: '例: 下端小径円筒部、CAD測定コマンドで法線方向を確認',
        rationale: '判断根拠',
        assignee: '担当者',
        dueDate: '期限',
        evidenceTitle: '保存される証跡',
        evidenceSummary: '解析値 {{analysis}} mm / CAD照合 {{mode}} / 処置 {{disposition}}',
        evidenceSummaryMeasured: '解析値 {{analysis}} mm / CAD照合 {{mode}} {{measured}} mm / 処置 {{disposition}}',
        lastCompleted: '前回完了: {{name}} / {{at}}',
        back: '戻る',
        next: '次へ',
        unsavedChanges: '未保存の変更があります。',
      },
      batch: {
        createTitle: '新しい一括解析を作成',
        loadFailed: '一括解析一覧を取得できませんでした。',
        startFailed: '一括解析を開始できませんでした。',
        openFailed: '部品の解析結果を開けませんでした。',
        retryFailed: '再実行を開始できませんでした。',
        reanalyzeFailed: '条件変更した再解析を開始できませんでした。',
        regionLabel: '一括解析パネル',
        scrollHelp: '一括解析パネルは縦にスクロールできます。完了を含むすべての部品は各バッチの「全件表示」で確認できます。',
        stepsLabel: '一括解析の手順',
        steps: {
          selectFiles: 'ファイル選択',
          conditions: '標準条件',
          submit: '受付・解析',
        },
        selectFiles: 'ファイルを選択（最大{{max}}件）',
        selectedCount: '{{count}}件を選択済み',
        fileSeparator: '、',
        conditionsTitle: '標準条件',
        showDetails: '詳細設定',
        hideDetails: '詳細を閉じる',
        lower: '下限',
        upper: '上限',
        tolerance: '公差',
        conditionSummary: '基準 {{lower}}〜{{upper}} mm / 判定公差 {{tolerance}} mm',
        finalRange: '最終合格範囲 {{lower}}〜{{upper}} mm',
        nameLabel: '一括解析名',
        namePlaceholder: '一括解析名（任意）',
        defaultName: '一括解析 {{timestamp}}',
        start: '一括解析を開始',
        submitting: '全ファイルを保存中…',
        backgroundNotice: '「受付完了」が表示された後は、この画面やPCを閉じても処理を継続します。',
        accepted: '{{count}}部品を受け付けました。ブラウザを閉じても解析は続きます。',
        readOnly: '一括解析の作成には編集権限が必要です。既存結果は確認できます。',
        listTitle: '一括解析一覧',
        refresh: '更新',
        empty: '一括解析はまだありません。',
        status: {
          processing: '処理中',
          needs_review: '要確認',
          completed: '完了',
          completed_with_failures: '一部失敗',
          failed: '失敗',
        },
        itemCounts: '要確認 {{needsReview}} / 完了 {{completed}} / 失敗 {{failed}} / 全{{total}}件',
        showAll: '全件表示',
        showFlaggedOnly: '要確認・失敗のみ',
        noFlaggedItems: '要確認・失敗の部品はありません。全件表示で完了結果を確認できます。',
        openItem: '結果を確認',
        retryItem: 'この部品だけ再実行',
        itemProcessing: 'サーバーで処理中',
        reanalyzeTitle: '条件を変更して再解析',
        reanalyze: 'この条件で再解析',
        partSearchLabel: '一括解析検索',
        partSearchPlaceholder: '解析名・部品名・フォルダ・タグで検索',
        machineFilter: '機種で絞り込み',
        allMachines: 'すべての機種',
        numberFilter: '番号で絞り込み',
        allNumbers: 'すべての番号',
        noPartSearchResults: '条件に一致する一括解析はありません。',
      },
      status: {
        pending: '待機中',
        processing: '解析中',
        completed: '完了',
        failed: '失敗',
      },
      reason: {
        non_watertight: '非水密メッシュのため測定方向に制約があります。',
        no_measurements: '有効な測定値を取得できませんでした。',
        low_hit_rate: '測定成功率が50%未満です。',
        sampled_faces: '面数制限により一部の面をサンプリングしています。',
        medium_profile: '中精度プロファイルによる暫定解析です。',
        coarse_profile: '粗精度プロファイルによる暫定解析です。',
        multiple_bodies_largest_only: '複数ボディのうち最大ボディのみを解析しています。',
        source_face_mapping_unavailable: '元CAD面との対応情報を取得できないため、CAD面単位の集約は表示しません。',
        untessellated_source_faces: '三角形化できなかった元CAD面があるため、面単位集約は一部のみです。',
      },
    },
};

export default core;
